/**
* Box Intro Content JS
* -----------------------------------------------------------------------------
*
* All the JS for the Box Intro Content component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'box-intro-content',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );
      //
      $( '.box-intro-content' ).each( function() {
        const _this = this;
        // $( _this ).find( '.image-gallery' ).slick( {
        //   arrows: true,
        //   dots: false,
        //   infinite: false,
        //   prevArrow: $( _this ).find( '.slider-nav .slider-prev' )[0],
        //   nextArrow: $( _this ).find( '.slider-nav .slider-next' )[0],
        // } );

        // $( _this ).find( '.image-gallery' ).on( 'beforeChange', function( event, slick, currentSlide, nextSlide ) {
        //   const realNextSlide = nextSlide + 1;
        //   const title = $( _this ).find( '.image-gallery .slide:nth-child(' + realNextSlide + ')' ).attr( 'data-title' );
        //   const subtitle = $( _this ).find( '.image-gallery .slide:nth-child(' + realNextSlide + ')' ).attr( 'data-subtitle' );
        //   const totalSlides = $( _this ).find( '.gallery-info .tracker' ).attr( 'data-total' );

        //   $( _this ).find( '.gallery-info .current-slide' ).text( realNextSlide );
        //   $( _this ).find( '.gallery-info .title' ).text( title );
        //   $( _this ).find( '.gallery-info .subtitle' ).text( subtitle );
        //   $( _this ).find( '.gallery-info .tracker' ).width( ( ( parseInt( realNextSlide ) / parseInt( totalSlides ) ) * 100 ) + '%' );
        // } );
      } );
      $( '.image-gallery-slider-wrapper.splide' ).each( function( index, comp ) {
        const _this = this;
        const currentSlider = new Splide( comp, {
          type: 'fade',
          perPage: 1,
          perMove: 1,
          gap: '50px',
          pagination: false,
          drag: false,
          live: true,
        } );

        currentSlider.on( 'overflow', function( isOverflow ) {
          currentSlider.options = {
            arrows: isOverflow,
          };
        } );

        const handleCaptions = ( index ) => {
          const destinationSlide = $( $( '.splide__slide' ).eq( index ).get( 0 ) ).find( '.image' ).get( 0 );
          $( _this ).find( '.gallery-info .title' ).text( $( destinationSlide ).attr( 'data-title' ) );
          $( _this ).find( '.gallery-info .subtitle' ).text( $( destinationSlide ).attr( 'data-subtitle' ) );
          $( _this ).find( '.gallery-info .current-slide' ).text( index + 1 );
        };

        const handleProgress = () => {
          const end = currentSlider.Components.Controller.getEnd() + 1;
          const rate = Math.min( ( currentSlider.index + 1 ) / end, 1 );
          $( _this ).find( '.gallery-info .tracker' ).width( String( 100 * rate ) + '%' );
        };

        // Updates the bar width whenever the carousel moves:
        currentSlider.on( 'mounted', function( ) {
          handleCaptions( 0 );
          handleProgress();
        } );
        // Updates the bar width whenever the carousel moves:
        currentSlider.on( 'move', function( newIndex, prevIndex, destIndex ) {
          handleCaptions( destIndex );
          handleProgress();
        } );

        currentSlider.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'box-intro-content', COMPONENT );
} )( app );
